export const normalizeSortedParam = (value: string): string =>
  value.split(',').filter(Boolean).sort().join(',');
